<template>
    <div>
        <PageHeader>
            {{ $t('settingsGdzieKupicTo') }}
            <template #subtitle>
                <div>{{ $t('goToTheSettingsAndAdjustTheAppearanceOfTheProductPage') }}</div>
            </template>
            <template #bottom>
                <div class="d-flex flex-wrap gap-3">
                    <ButtonIcon
                        icon="file-text"
                        :icon-size="24"
                        variant="link"
                        class="p-0 text-wrap"
                        @click="openHelp"
                    >
                        {{ $t('takeALookAtHelp') }}
                    </ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <Card :header="$t('pagesList')">

            <div v-if="request.loading && !items.length" class="d-flex justify-content-center my-2">
                <b-spinner />
            </div>

            <Results v-else-if="items.length" ref="Results" />

            <AddFirstSpace v-else />

        </Card>
    </div>
</template>



<script>
    import Results from './parts/Results.vue';
    import AddFirstSpace from './parts/AddFirstSpace.vue';

    export default {
        name: 'Settings',
        components: {
            Results,
            AddFirstSpace,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                request: this.$req('buyboxes/LandingPages'),
            };
        },
        computed: {
            user() {
                return this.$store.getters['auth/getUser'];
            },
            items() {
                return this.request.getData() || [];
            },
            loading() {
                return this.request.getLoading();
            },
            error() {
                return this.request.getError();
            },
        },
        methods: {
            openHelp() {
                window.Gleap.openHelpCenterArticle('23', false);
            },
            fetchData() {
                this.request.get({ urlParams: { id: this.user.id }, requestParams: { statuses: '1,2' } });
            },
        },
        created() {
            this.fetchData();
        },
    };
</script>

